import withSuspense from "../../../../hocs/withSuspense";
import { EditNamePageProps, EditNamePage } from "./EditNamePage";
import { ContactInfoError, ContactInfoSkeleton } from "../../components";

export const EditNamePageWithSuspense = withSuspense<EditNamePageProps>(
  EditNamePage,
  {
    FallbackComponent: ContactInfoError,
    loading: <ContactInfoSkeleton rows={3} testId="edit-name" />,
  }
);
